export const SET_MERCHANTS = "SET_MERCHANTS";
export const SELECTED_MERCHANT = "SELECTED_MERCHANT";
export const SET_MERCHANT = "SET_MERCHANT";
export const SET_TARGETS = "SET_TARGETS";
export const SET_TARGETS_NULL = "SET_TARGETS_NULL";
